module.exports = __webpack_public_path__ + "img/file-word.2c4b46a6.svg";